import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createShallowStoreHook } from './createShallowStoreHook';
import { ProxyTypeName } from '@fd/common/biz/proxyType';

export type CartItem = {
  type: ProxyTypeName;
  quantity: number;
};

type CartStore = {
  items: CartItem[];
  addItem: (item: CartItem) => void;
  removeItem: (index: number) => void;
  updateItemQuantity: (index: number, quantity: number) => void;
  clearCart: () => void;
};

export const useCartStore = create<CartStore>()(
  persist(
    (set) => ({
      items: [],
      
      addItem: (newItem) => set((state) => {
        const existingItemIndex = state.items.findIndex(
          (item) => item.type === newItem.type
        );

        if (existingItemIndex !== -1) {
          // Item with same proxy type exists, update quantity
          const updatedItems = [...state.items];
          updatedItems[existingItemIndex] = {
            ...updatedItems[existingItemIndex],
            quantity: updatedItems[existingItemIndex].quantity + newItem.quantity,
          };
          return { items: updatedItems };
        }
        
        // Add new item to basket
        return { items: [...state.items, newItem] };
      }),
      
      removeItem: (index) => set((state) => ({
        items: state.items.filter((_, i) => i !== index)
      })),
      
      updateItemQuantity: (index, quantity) => set((state) => {
        const updatedItems = [...state.items];
        if (index >= 0 && index < updatedItems.length) {
          updatedItems[index] = {
            ...updatedItems[index],
            quantity,
          };
        }
        return { items: updatedItems };
      }),
      
      clearCart: () => set({ items: [] }),
    }),
    {
      name: 'cart-storage',
    }
  )
);

// Create a hook with shallow comparison
const useCart = createShallowStoreHook(useCartStore);

export default useCart;
